import { render, staticRenderFns } from "./wallet-box2.vue?vue&type=template&id=548e70a1&scoped=true&"
import script from "./wallet-box2.vue?vue&type=script&lang=js&"
export * from "./wallet-box2.vue?vue&type=script&lang=js&"
import style0 from "./wallet-box2.vue?vue&type=style&index=0&id=548e70a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e70a1",
  null
  
)

export default component.exports